import { combineReducers } from 'redux'
import {modal} from "../ui/modal/reducer";
import {error} from "../error/reducer";
import {table} from "./reducer";

export default combineReducers({
  table, modal, error
})